import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { x } from '@xstyled/styled-components';
import { useRating } from '../../hooks/use-rating';
import { When, SectionModal, RatingForm, RatingSuccess } from '@aftersale-next/ui';
import { useTranslation } from 'react-i18next';
export function Rating(_ref) {
  var type = _ref.type;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useRating = useRating(type),
      rate = _useRating.rate,
      data = _useRating.data,
      error = _useRating.error,
      isSuccess = _useRating.isSuccess,
      isLoading = _useRating.isLoading,
      isReadyToRate = _useRating.isReadyToRate;

  if (!isReadyToRate) return /*#__PURE__*/_jsx(Fragment, {});
  return /*#__PURE__*/_jsxs(SectionModal, {
    children: [/*#__PURE__*/_jsx(When, {
      value: !isSuccess,
      children: /*#__PURE__*/_jsx(RatingForm, {
        rating: data.rating,
        commentary: data.commentary,
        onSubmit: rate,
        disableSubmit: isLoading,
        enableCommentary: true,
        formType: "CSAT"
      })
    }), /*#__PURE__*/_jsx(When, {
      value: !!error,
      children: /*#__PURE__*/_jsx(x.p, {
        mt: "8px",
        color: "red-500",
        w: "full",
        textAlign: "center",
        "data-testid": "feedback-error-message",
        children: t('FEEDBACK_ERROR_MESSAGE')
      })
    }), /*#__PURE__*/_jsx(When, {
      value: isSuccess,
      children: /*#__PURE__*/_jsx(RatingSuccess, {})
    })]
  });
}